import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute, browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import { DrizzleProvider } from 'drizzle-react';
import { EthereumLoader } from './components';
import Navigation from './layouts/navigation/Navigation';

// Layouts
import HomeContainer from './layouts/home/HomeContainer';
import { AliasInfo, MarketPlace, Address, MissingPage } from './components';

import store from './store';
import drizzleOptions from './drizzleOptions';

// Styles
import './css/oswald.css'
import './css/open-sans.css'
import './css/style.css'

// Initialize react-router-redux.
const history = syncHistoryWithStore(browserHistory, store)

ReactDOM.render((
    <DrizzleProvider options={drizzleOptions} store={store}>
      <EthereumLoader>
        <Router history={history}>
          <Route path="/" component={Navigation} >
            <IndexRoute component={HomeContainer} />
            <Route path="/find" component={AliasInfo} />
            <Route path="/set" component={AliasInfo} />
            <Route path="/market" component={MarketPlace} />
            <Route path="/e/:alias" component={Address} />
            <Route path="*" component={MissingPage} />
          </Route>
        </Router>
      </EthereumLoader>
    </DrizzleProvider>
  ),
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js